<template>
  <div style="width: 100%;background-color: #FFFFFF">
    <div style="width: 1100px;">
      <el-form class="formDiv" label-width="125px" ref="formContract" :model="formContract" :rules="rulesContract"
        style="padding: 40px 0 40px 20px">
        <el-form-item label="合同编号" prop="contractNumber">
          <div style="display:flex;align-items: center">
            <el-input style="width: 330px;" v-model="formContract.contractNumber" auto-complete="off" disabled
              :readonly=true placeholder="请获取合同编号">
            </el-input>
            <el-tooltip content="复制">
              <a-icon type="copy" style="color: #3f9dfe" @click="copyData(formContract.contractNumber)" />
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="有效期限" prop="expirationDate">
          <el-select style="width: 330px;" disabled v-model="formContract.expirationDate" placeholder="请选择有效期限"
            filterable>
            <el-option v-for="item in DateOptions" :key="item.label" :label="item.name" :value="item.label"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="contractName">
          <template #label>
            <div style="position: relative; display: inline-block;margin-right: 10px;">
              <span>合同名称</span>
              <el-popover placement="top" width="200" trigger="click"
                content="不支持使用<  >  :  &quot;  /  \  |  ?  *  +；仅支持数字/汉字/英文/( - _ )等">
                <sup slot="reference" style="position: absolute; top: 10px; right: -15px; cursor: pointer;">
                  <i class="el-icon-info" style="color: #409EFF; font-size: 14px;"></i>
                </sup>
              </el-popover>
            </div>
          </template>
          <div style="display:flex;align-items: center">
            <el-input style="width: 330px;" v-model="formContract.contractName" auto-complete="off"
              placeholder="请输入合同名称"></el-input>
            <el-button type="primary" style="margin-left: 10px" size="mini" @click="createName">生成</el-button>
          </div>
        </el-form-item>
        <el-form-item label="合同金额" prop="contractAmount" style="width: 55%!important;">
          <div style="display:flex;align-items: center">
            <el-input style="width: 330px;" v-model="formContract.contractAmount" auto-complete="off"
              :disabled="formContract.contractType === 'DEVELOPMENT'" placeholder="请输入合同金额"></el-input>
            <el-button type="success" style="margin-left: 10px" size="mini" @click="addAllAmount">累加</el-button>
          </div>
        </el-form-item>
        <div style="width: 100%;margin-left: 45px;font-size: 14px;color: red;margin-bottom: 10px;">{{ '注：合同名称不支持使用<> :"/\\ | ?* + 字符，仅支持数字 / 汉字 / 英文 / (- _ )等' }}</div>
        <el-form-item label="合同拟定时间" prop="contractDraftingDate">
          <el-input style="width: 330px;" v-model="formContract.contractDraftingDate" auto-complete="off"
            placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
        </el-form-item>
        <el-form-item label="销售" prop="salesId">
          <el-input style="width: 330px;" v-model="formContract.salesId" auto-complete="off"
            placeholder="请输入销售名称"></el-input>
        </el-form-item>
        <el-form-item label="甲方项目联系人" prop="customerContactsId" v-if="formContract.contractType !== 'DEVELOPMENT'">
          <el-input style="width: 330px;" v-model="formContract.customerContactsId" auto-complete="off"
            placeholder="请输入甲方项目联系人名称"></el-input>
        </el-form-item>

        <el-form-item label="乙方(受托方)" prop="trusteeCompanyId">
          <el-select style="width: 330px;" v-model="formContract.trusteeCompanyId" placeholder="请选择" filterable>
            <el-option v-for="item in businessOption" :key="item.id" :label="item.companyName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="乙方项目联系人" prop="trusteeContactsId" v-if="formContract.contractType !== 'DEVELOPMENT'">
          <el-input style="width: 330px;" v-model="formContract.trusteeContactsId" auto-complete="off"
            placeholder="请输入乙方项目联系人名称"></el-input>
        </el-form-item>


        <el-form-item label="合同分类" prop="contractType">
          <el-select style="width: 330px;" v-model="formContract.contractType" placeholder="请选择合同分类" filterable
            @change="changeContractType(formContract.contractType)">
            <el-option v-for="item in TypeOptions" :key="item.label" :label="item.name" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同类型" prop="projectType">
          <el-select style="width: 330px;" v-model="formContract.projectType" placeholder="请选择合同类型" filterable
            @change="changeProjectType">
            <el-option v-for="item in DirectionOptions.filter(item => item.label !== '微生态保护液')" :key="item.label" :label="item.label"
              :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签订地点" prop="signingPlace">
          <el-input placeholder="请输入签订地点" style="width: 330px;" v-model="formContract.signingPlace">
          </el-input>
        </el-form-item>

        <div
          v-if="['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(formContract.projectType) && formContract.contractType !== 'DEVELOPMENT'"
          style="width: 100%">
          <div style="display:flex;width: 100%">
            <el-form-item label="是否返样" prop="returnFlag">
              <el-select style="width: 330px;" v-model="formContract.returnFlag" placeholder="请选择是否返样" filterable>
                <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务费(返样)" prop="sampleAmount" v-if="formContract.returnFlag === true">
              <el-input style="width: 330px;" v-model="formContract.sampleAmount" auto-complete="off"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="金额为0原因" prop="reason" v-if="Number(formContract.sampleAmount) === 0 && formContract.returnFlag === true
            && formContract.sampleAmount !== ''" style="width: 87%!important;">
            <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请填写服务费(返样)为0的原因"
              v-model="formContract.reason" maxlength="300" show-word-limit>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="formContract.contractType === 'CHARGEBACKS'" label="甲方可扣款金额" prop="remainingAmount">
          <el-input style="width: 330px;" disabled v-model="formContract.remainingAmount"></el-input>
        </el-form-item>
        <el-form-item v-if="formContract.contractType === 'PREPAYMENTS'" label="增值金额" prop="addedAmount">
          <el-input style="width: 330px;" v-model="formContract.addedAmount" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="纯分析评估人" prop="pureAnalysisEvaluateId"
          v-if="formContract.projectType === '预付款扣款（纯分析）' || formContract.projectType === '纯分析'">
          <el-select style="width: 330px;" v-model="formContract.pureAnalysisEvaluateId" placeholder="请选择纯分析评估人"
            filterable>
            <el-option v-for="item in AnalysisEvaluateOptions" :key="item.uuid" :label="item.name"
              :value="item.uuid"></el-option>
          </el-select>
        </el-form-item> -->

       <el-form-item label="样品处理方式" prop="sampleManagement" v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(formContract.projectType)">
          <template #label>
            <span style="background-color: #ffff00;color: #ff1c00;font-weight: bold;">样品处理方式</span>
          </template>
          <el-radio-group v-model="formContract.sampleManagement">
            <el-radio label="RETURN_SAMPLE">返样</el-radio>
            <el-radio label="SAMPLE_HOLD">暂存样品</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="formContract.contractType === 'TEAM'" style="width: 100%;margin-bottom: 5px">
          <div
            :style="{ width: '90%!important', display: 'flex', flexDirection: 'column', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
            <span style="font-size: 14px; font-weight: 600; margin-bottom: 6px;">团队费用合同说明</span>
            <span style="font-size: 12px; color: red; line-height: 1.8;">
              <span style="display: block;">1. 试做项目（金额&lt;=800，价格按照报价表的价格）</span>
              <span style="display: block;">2. 项目售后</span>
              <span style="display: block;">3. 原始数据重释放</span>
              <span style="display: block;">4. 销售/客户对数据有疑问；后台核查没问题；还要重做；</span>
              <span style="display: block;">5. 纯分析（金额&lt;1500，走团队费用的纯分析不允许打折）</span>
              <span style="display: block;">6. 外送的项目不允许；测序分析项目不允许部分费用走：团队费用。</span>
            </span>
          </div>
        </div>
        <div style="width: 100%;margin-bottom: 20px">
          <div style="margin-top: 5px;" v-if="projectTypeData.includes(formContract.projectType)">
            <div
              :style="{ width: '90%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
              <span style="font-size: 14px; font-weight: 600;">项目信息</span>
              <div style="display:flex; align-items:center; gap: 10px;">
                <el-button type="success" size="mini" icon="el-icon-plus" @click="handleAddProject">添加</el-button>
              </div>
            </div>
            <div style="width: 100%;display:flex;align-items: center;"
              v-for="(project, index) in formContract.specificProjectType" :key="index">
              <div
                style="display: flex;flex-wrap: wrap;padding-top:20px;border: 1px dashed #d9d9d9;border-top: none;width: 90%!important;">
                <el-form-item label="项目模块" style="width: 32%!important;"
                  :prop="'specificProjectType.' + index + '.projectClassification'"
                  :rules="{ required: true, message: '请选择项目模块', trigger: 'change' }">
                  <el-select v-model="project.projectClassification" placeholder="请选择项目模块" filterable
                    @change="changeProject(project)">
                    <el-option
                      v-for="item in TypeOption.filter(item => !item.disabled.includes(formContract.projectType) && !(formContract.contractType === 'TEAM' && item.label === 'METAPRO'))"
                      :key="item.label" :label="item.name" :value="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="project.projectClassification !== '硬盘购买' ? '项目类型' : '硬盘大小'"
                  style="width: 32%!important;" :prop="'specificProjectType.' + index + '.projectType'"
                  :rules="{ required: true, message: '请选择项目类型', trigger: 'change' }">
                  <el-select v-model="project.projectType" placeholder="请选择项目类型" filterable
                    @change="changeType(project)">
                    <el-option v-for="item in filterOptions(project.projectClassification, project.projectType)"
                      :disabled="item.deprecated" :key="item.name" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="项目金额" :prop="'specificProjectType.' + index + '.projectAmount'"
                  style="width: 32%!important;" v-if="!(project.experimental && project.experimental.length > 0)"
                  :rules="formContract.contractType !== 'DEVELOPMENT' ? [{ required: true, message: '请输入项目金额', trigger: 'change' },
                  (project.experimental && project.experimental.length > 0)
                    ? { validator: (rule, value, callback) => checkSumAmount(rule, value, project.labList, project.experimental, callback, true), trigger: 'change' }
                    : { validator: checkNum, trigger: 'change' }] : { required: false, message: '请输入项目金额', trigger: 'change' }">
                  <div style="display: flex;align-items: center">
                    <el-input v-model="project.projectAmount" auto-complete="off"
                      :disabled="formContract.contractType === 'DEVELOPMENT'" placeholder="请输入项目金额"></el-input>
                  </div>
                </el-form-item>
                <div style="width: 100%!important;display: flex;justify-content: center;"
                  v-if="project.experimental && project.experimental.length > 0">
                  <div style="width: 98%;display: flex;flex-wrap:wrap;border:1px dashed #d9d9d9;padding-top: 20px">
                    <el-form-item label="实验过程" :prop="'specificProjectType.' + index + '.labList'"
                      style="width: 99%!important;margin-bottom: 0" label-width="135px"
                      :rules="[{ required: true, message: '请选择实验过程', trigger: 'change' }, { validator: (rule, value, callback) => checkInclude(rule, value, callback, ['引物合成', '荧光定量'], project.experimental.map(item => item.experimentName)), trigger: 'change' }]">
                      <el-checkbox-group v-model="project.labList" style="width:100%">
                        <el-checkbox v-for="(lab, labIndex) in project.experimental"
                          style="width:45%;margin-bottom:20px" :key="labIndex" :label="lab.experimentName"
                          :disabled="['引物合成', '荧光定量'].includes(lab.experimentName) && project.labList.includes(lab.experimentName)">
                          <div style="display:flex;align-items:center">
                            <span style="width:65px">{{ lab.experimentName }}</span>
                            <el-form-item label-width="12px"
                              :prop="'specificProjectType.' + index + '.experimental.' + labIndex + '.numberOfExperiment'"
                              :rules="[{ required: project.labList.includes(lab.experimentName), message: '请输入数量', trigger: 'change' },
                              { validator: checkNumber, trigger: 'change' }]" style="width:48%!important">
                              <el-input v-model="lab.numberOfExperiment" auto-complete="off" placeholder="数量"
                                :disabled="!project.labList.includes(lab.experimentName)"></el-input>
                            </el-form-item>
                            <el-form-item label-width="12px" style="width:48%!important"
                              :prop="'specificProjectType.' + index + '.experimental.' + labIndex + '.experimentAmount'"
                              :rules="[{ required: project.labList.includes(lab.experimentName), message: '请输入金额', trigger: 'change' },
                              (formContract.contractType === 'DEVELOPMENT') ? { validator: checkNumber, trigger: 'change' } : { validator: checkNum, trigger: 'change' }]">
                              <el-input @input="(value) => addProjectAmount(value, index)"
                                v-model="lab.experimentAmount" auto-complete="off" placeholder="金额"
                                :disabled="!project.labList.includes(lab.experimentName)"></el-input>
                            </el-form-item>
                          </div>
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </div>
                </div>

                <div style="width: 100%;margin-bottom: 20px"
                  v-if="!(project.experimental && project.experimental.length > 0)">
                  <div v-for="(dataItem, dataIndex) in project.projectSampleDataList" :class="['custom-style']">
                    <div
                      :style="{ display: 'flex', width: '95%', 'align-items': 'center', 'flex-wrap': 'wrap', 'border': '1px dashed #d9d9d9', 'border-top-style': dataIndex !== 0 ? 'none' : 'dashed', 'margin-left': '10px' }">
                      <el-form-item label="样品数量"
                        :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.numberOfSamples'"
                        style="width: 32%!important;margin-top: 10px;"
                        :rules="[{ required: true, message: '请输入样品数量', trigger: 'change' },
                        (project.experimental && project.experimental.length > 0) ? { validator: (rule, value, callback) => checkSum(rule, value, callback, project.minSampleCount, project.maxSampleCount, project.labList, project.experimental), trigger: 'change' } : { validator: (rule, value, callback) => checkMinMax(rule, value, callback, project.minSampleCount, project.maxSampleCount), trigger: 'change' }]">
                        <div style="display: flex;align-items: center">
                          <el-input v-model="dataItem.numberOfSamples" auto-complete="off"
                            placeholder="请输入样品数量"></el-input>
                        </div>
                      </el-form-item>
                      <div style="display: flex; align-items: center;width: 66%!important;margin-top: 15px"
                        v-for="(info, sonIndex) in dataItem.projectList"
                        v-if="(project.sequencingPlatformList && project.sequencingPlatformList.length > 0) && project.sequencingPlatformType === info.name && info.value !== 'NOT' && ['二代', '三代'].includes(info.name)">
                        <el-form-item style="width: 1%!important;" label-width="10px">
                          <el-checkbox v-model="info.boolean" :disabled="info.value !== 'CHOOSE'"></el-checkbox>
                        </el-form-item>
                        <el-form-item :label="info.name + '数据量'"
                          :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.projectList.' + sonIndex + '.size'"
                          :rules="[{ required: info.boolean, message: '请输入样品数据量', trigger: 'change' },
                          { validator: (rule, value, callback) => checkSize(rule, value, callback, project.projectClassification === 'AMPLICON' ? 10000 : ''), trigger: 'change' }]"
                          style="width: 48%!important;">
                          <el-input v-model="info.size" auto-complete="off" :disabled="!info.boolean"
                            placeholder="请输入"><template #suffix><span style="color: #606266;margin-right: 3px;">{{ ' ('
                              +
                              project.dataAmountUnit + ')'
                                }}</span></template></el-input>
                        </el-form-item>
                        <el-form-item label="检测平台" :prop="'specificProjectType.' + index + '.sequencingPlatform'"
                          style="width: 48%!important;"
                          :rules="{ required: true, message: '请选择检测平台', trigger: 'change' }">
                          <el-select v-model="project.sequencingPlatform" placeholder="请选择检测平台"
                            :disabled="project.sequencingPlatformList.length === 1 || dataIndex !== 0" filterable>
                            <el-option v-for="item in project.sequencingPlatformList" :key="item" :label="item"
                              :value="item"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div style="display: flex; align-items: center;width: 32%!important;margin-top: 15px"
                        v-for="(info, sonIndex) in dataItem.projectList"
                        v-if="!((project.sequencingPlatformList && project.sequencingPlatformList.length > 0) && project.sequencingPlatformType === info.name) && info.value !== 'NOT'">

                        <el-form-item style="width: 1%!important;" label-width="10px">
                          <el-checkbox v-model="info.boolean" :disabled="info.value !== 'CHOOSE'"></el-checkbox>
                        </el-form-item>
                        <el-form-item :label="info.name + '数据量'"
                          :prop="'specificProjectType.' + index + '.projectSampleDataList.' + dataIndex + '.projectList.' + sonIndex + '.size'"
                          :rules="[{ required: info.boolean, message: '请输入样品数据量', trigger: 'change' },
                          { validator: (rule, value, callback) => checkSize(rule, value, callback, project.projectClassification === 'AMPLICON' ? 10000 : ''), trigger: 'change' }]"
                          style="width: 99%!important;">
                          <el-input v-model="info.size" auto-complete="off" :disabled="!info.boolean"
                            placeholder="请输入"><template #suffix><span style="color: #606266;margin-right: 3px;">{{ ' ('
                              +
                              project.dataAmountUnit + ')'
                                }}</span></template></el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div
                      style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                      <el-button type="danger" icon="el-icon-delete" size="mini"
                        :disabled="['METAPRO', '硬盘购买', 'PCR'].includes(project.projectClassification)"
                        @click="handleDeleteData(index, dataIndex)" style="margin-bottom: 2px;"></el-button>
                      <el-button type="success" icon="el-icon-plus" style="margin: 1px 0 0;"
                        :disabled="['METAPRO', '硬盘购买', 'PCR'].includes(project.projectClassification)"
                        v-if="dataIndex === project.projectSampleDataList.length - 1" size="mini"
                        @click="handleAddData(index)"></el-button>
                    </div>
                  </div>
                </div>

                <div style="width: 100%!important;display: flex; flex-wrap: wrap;" v-if="!['预付款扣款（裸测）', '裸测'].includes(formContract.projectType)">
                  <el-form-item label="分析要求" :prop="'specificProjectType.' + index + '.analysis'"
                    style="width: 49%!important;"
                    v-if="project.projectClassification && project.projectClassification !== '硬盘购买'" label-width="135px"
                    :rules="[{ required: true, message: '请选择分析要求', trigger: 'change' }]">
                    <el-radio-group v-model="project.analysis">
                      <el-radio label="标准分析">标准分析</el-radio>
                      <el-radio label="非标准分析">非标准分析</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="解离样品投递方式" style="width: 48%!important;" label-width="135px"
                    prop="protectiveFluidInfo.protectiveFluidMethod"
                    v-if="['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].includes(project.projectType)"
                    :rules="[{ required: true, message: '请选择解离样品投递方式', trigger: 'change' }]">
                    <el-radio-group v-model="formContract.protectiveFluidInfo.protectiveFluidMethod">
                      <el-radio label="DOOR">上门</el-radio>
                      <el-radio label="MAIL">邮寄</el-radio>
                    </el-radio-group>
                  </el-form-item>
                 <div style="width: 100%; display: flex; flex-wrap: wrap; margin-top: 10px;"
                    v-if="['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].includes(project.projectType)">
                    <template v-if="formContract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR'">
                      <el-form-item label="上门时间" style="width: 48%!important;"
                        prop="protectiveFluidInfo.doorInfo.doorTime"
                        :rules="[{ required: true, message: '请输入上门时间', trigger: 'change' }, { validator: checkDate, trigger: 'change' }]">
                        <el-input v-model="formContract.protectiveFluidInfo.doorInfo.doorTime" auto-complete="off"
                          placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                      </el-form-item>
                      <el-form-item label="上门费用" style="width: 48%!important;"
                        prop="protectiveFluidInfo.doorInfo.doorFee"
                        :rules="[{ required: true, message: '请输入上门费用', trigger: 'change' }, { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 3000), trigger: 'change' }]">
                        <el-input v-model="formContract.protectiveFluidInfo.doorInfo.doorFee" auto-complete="off"
                          placeholder="请输入上门费用"></el-input>
                        <template #label>
                          <span>上门费用</span>
                          <span style="font-size: 12px; color: #606266; margin-top: 2px;">&ge;3000</span>
                        </template>
                      </el-form-item>
                      <el-form-item label="联系方式" style="width: 48%!important;" prop="protectiveFluidInfo.doorInfo.phone"
                        :rules="[{ required: true, message: '请输入联系方式', trigger: 'change' }]">
                        <el-input v-model="formContract.protectiveFluidInfo.doorInfo.phone" auto-complete="off"
                          placeholder="请输入联系方式"></el-input>
                      </el-form-item>
                      <el-form-item label="上门地址" style="width: 48%!important;"
                        prop="protectiveFluidInfo.doorInfo.address"
                        :rules="[{ required: true, message: '请输入上门地址', trigger: 'change' }]">
                        <el-input v-model="formContract.protectiveFluidInfo.doorInfo.address" auto-complete="off"
                          placeholder="请输入上门地址"></el-input>
                      </el-form-item>
                    </template>
                    <template v-else-if="formContract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'">
                      <el-form-item label="邮寄时间" style="width: 48%!important;"
                        prop="protectiveFluidInfo.materialMailInfo.mailTime"
                        :rules="[{ required: true, message: '请输入邮寄时间', trigger: 'change' }, { validator: checkDate, trigger: 'change' }]">
                        <el-input v-model="formContract.protectiveFluidInfo.materialMailInfo.mailTime"
                          auto-complete="off" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                      </el-form-item>
                      <el-form-item label="收件人" style="width: 48%!important;"
                        prop="protectiveFluidInfo.materialMailInfo.recipient"
                        :rules="{ required: true, message: '请输入收件人', trigger: 'change' }">
                        <el-input v-model="formContract.protectiveFluidInfo.materialMailInfo.recipient"
                          auto-complete="off" placeholder="请输入收件人"></el-input>
                      </el-form-item>
                      <el-form-item label="收件人电话" style="width: 48%!important;"
                        prop="protectiveFluidInfo.materialMailInfo.phone"
                        :rules="{ required: true, message: '请输入收件人电话', trigger: 'change' }">
                        <el-input v-model="formContract.protectiveFluidInfo.materialMailInfo.phone" auto-complete="off"
                          placeholder="请输入收件人电话"></el-input>
                      </el-form-item>
                      <el-form-item label="收件地址" style="width: 48%!important;"
                        prop="protectiveFluidInfo.materialMailInfo.address"
                        :rules="{ required: true, message: '请输入收件地址', trigger: 'change' }">
                        <el-input v-model="formContract.protectiveFluidInfo.materialMailInfo.address"
                          auto-complete="off" placeholder="请输入收件地址"></el-input>
                      </el-form-item>
                    </template>
                  </div>
                  <el-form-item label="标准分析具体类型" :prop="'specificProjectType.' + index + '.analysisList'"
                    style="width: 98%!important;" label-width="135px"
                    v-if="project.analysis === '标准分析' && project.analysisChoiceList.length > 0 && !(project.analysisChoiceList.includes('标准分析') && project.analysisChoiceList.length === 1)"
                    :rules="[{ required: true, message: '请选择标准分析具体类型', trigger: 'change' }]">
                    <el-checkbox-group v-model="project.analysisList" v-if="project.multipleChoice"
                      @change="(value) => changeAnalysisChoice(value, project)">
                      <el-checkbox v-for="(choiceItem, choiceIndex) in project.analysisChoiceList" :key="choiceIndex"
                        :label="choiceItem"></el-checkbox>
                    </el-checkbox-group>
                    <el-radio-group v-model="project.analysisList[0]" v-if="!project.multipleChoice">
                      <el-radio v-for="(choiceItem, choiceIndex) in project.analysisChoiceList" :key="choiceIndex"
                        :label="choiceItem"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
              <div
                style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                <el-button type="danger" icon="el-icon-delete" size="small" @click="handleDeleteProject(project)"
                  style="margin-bottom: 2px;"></el-button>
              </div>
            </div>
          </div>


        
          <div style="margin-top: 5px;"
            v-if="targetList.includes(formContract.projectType) || (['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => formContract.specificProjectType.map(project => project.projectType).includes(item)) && formContract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL')">
            <div
              :style="{ width: '90%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
              <span style="font-size: 14px; font-weight: 600;">物料申领</span>
              <div style="display:flex; align-items:center; gap: 10px;">
                <el-button type="success" size="mini" icon="el-icon-plus" @click="handleAddMaterial">添加</el-button>
              </div>
            </div>
            <div v-for="(material, index) in formContract.materials" :key="index"
              style="width: 100%;display:flex;align-items: center;">
             <div
                :style="{ display: 'flex', width: '90%', flexWrap: 'wrap', paddingTop: '20px', border: '1px dashed #d9d9d9', borderTop: 'none' }">
                <el-form-item label="物料名称" :prop="'materials.' + index + '.materialId'" style="width: 33%!important;"
                  :rules="{ required: true, message: '请选择物料', trigger: 'change' }">
                  <el-select v-model="material.materialId" placeholder="请选择物料" filterable
                    @change="changeNumber(material.materialId, index)">
                    <el-option v-for="item in filterOption(material.materialId)" :key="item.id"
                      :label="'物料:' + item.materialName + '，剩余:' + item.number" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="物料规格" :prop="'materials.' + index + '.specs'" style="width: 33%!important;"
                  :rules="{ required: true, message: '请选择物料规格', trigger: 'change' }">
                  <el-select v-model="material.specs" placeholder="请选择物料规格" filterable>
                    <el-option v-for="item in filterSpecsOption(material.materialId, material.specs)" :key="item"
                      :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label-width="147px" style="width: 33%!important;" label="申领数量"
                  :prop="'materials.' + index + '.materialNumber'"
                  :rules="[{ required: true, message: '请输入申领数量', trigger: 'change' },
                  { validator: (rule, value, callback) => check(rule, value, material.remainingNumber, materialNumber[material.materialId], callback), trigger: 'change' }]">
                  <el-input-number style="width: 100%" v-model="material.materialNumber" :min="1"></el-input-number>
                </el-form-item>
              </div>
              <div
                style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
               <el-button type="danger" icon="el-icon-delete" size="mini" style="margin-bottom: 2px;"
                  @click="handleDeleteMaterial(material)"></el-button>
              </div>
            </div>
          </div>


         <div style="margin-top: 5px;width: 100%;"
            v-if="formContract.contractType === 'TEAM' && formContract.projectType === '纯分析'">
            <div
              :style="{ width: '90%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
              <span style="font-size: 14px; font-weight: 600; flex-shrink: 0;">纯分析项目选择</span>
              <span style="display: flex; align-items: flex-start; font-size: 12px; color: red; margin: 0 20px; line-height: 1.5; max-width: 50%; text-align: left;">
                <span style="flex-shrink: 0;">注：</span>
                <span>售后分析选择的合同号必须是已完成分析的，状态从管理系统获取；<br />原始数据重释放选择的项目是已经释放过原始数据的项目，状态从管理系统获取。</span>
              </span>
              <el-button type="success" size="mini" icon="el-icon-plus" style="flex-shrink: 0;"
                v-if="['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(formContract.pureAnalysisInfo.pureAnalysisType)"
                @click="addPureAnalysisContract">添加</el-button>
            </div>
            <div style="width: 100%;">
              <div v-for="(item, index) in formContract.pureAnalysisInfo.contracts" :key="index"
                style="display: flex; align-items: center; width: 100%;">
                <!-- 边框内容区：纯分析类型 / 合同 / 项目 -->
                <div style="width: 90%; display: flex; align-items: flex-start; gap: 10px; border: 1px dashed #d9d9d9; border-top: none; padding: 20px 0;">
                  <!-- 首列：第一行放「纯分析类型」，其余行放等宽占位以与第一项对齐 -->
                  <el-form-item v-if="index === 0" label="纯分析类型" prop="pureAnalysisInfo.pureAnalysisType"
                    style="flex: 1 1 33%; max-width: 33%; min-width: 0;"
                    :rules="[{ required: true, message: '请选择纯分析类型', trigger: 'change' }]">
                    <el-select v-model="formContract.pureAnalysisInfo.pureAnalysisType" placeholder="请选择纯分析类型"
                      filterable @change="changePureAnalysisType">
                      <el-option v-for="type in pureAnalysisTypeOptions" :key="type.value" :label="type.label"
                        :value="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <div v-else style="flex: 1 1 33%; max-width: 33%; min-width: 0;"></div>
                  <!-- 合同 / 项目：仅售后分析、原始数据重释放时显示 -->
                  <template v-if="['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(formContract.pureAnalysisInfo.pureAnalysisType)">
                    <el-form-item label="合同" :prop="'pureAnalysisInfo.contracts.' + index + '.contractId'"
                      style="flex: 1 1 33%; max-width: 33%; min-width: 0;"
                      :rules="[{ required: true, message: '请选择合同', trigger: 'change' }]">
                      <el-select v-model="item.contractId" placeholder="请输入合同编号搜索"
                        filterable remote reserve-keyword clearable
                        :remote-method="(query) => getEnforceContractOption(query, index)"
                        :loading="contractLoading" @change="changePureAnalysisContract(index)">
                        <el-option v-for="opt in item.options" :key="opt.id"
                          :label="opt.contractNumber" :value="opt.id"
                          :disabled="isContractOptionDisabled(opt.id, index)"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="项目" :prop="'pureAnalysisInfo.contracts.' + index + '.projectIds'"
                      style="flex: 1 1 33%; max-width: 33%; min-width: 0;"
                      :rules="[{ required: true, message: '请选择项目', trigger: 'change' }]">
                      <el-select v-model="item.projectIds" placeholder="请先选择合同"
                        filterable multiple reserve-keyword clearable
                        :multiple-limit="formContract.pureAnalysisInfo.pureAnalysisType === 'AFTER_SALES_ANALYSIS' ? 1 : 0"
                        :disabled="!item.contractId">
                        <el-option v-for="opt in getProjectOptions(item)" :key="opt.id"
                          :label="opt.label" :value="opt.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </div>
                <!-- 删除按钮：移到边框外右侧，与物料/硬盘选购保持一致 -->
                <div v-if="['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(formContract.pureAnalysisInfo.pureAnalysisType)"
                  style="justify-content: center; display: flex; flex-wrap: wrap; margin-left: 10px; width: 50px; margin-right: 10px;">
                  <el-button type="danger" size="mini" icon="el-icon-delete"
                    :disabled="formContract.pureAnalysisInfo.contracts.length <= 1"
                    @click="removePureAnalysisContract(index)" style="margin-bottom: 2px;"></el-button>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 5px;width: 100%;" v-if="hardDiskList.includes(formContract.projectType) && formContract.contractType !== 'TEAM'">
            <div
              :style="{ width: '90%!important', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', border: '1px dashed #d9d9d9', background: '#fafafa' }">
              <span style="font-size: 14px; font-weight: 600;">硬盘选购信息</span>
              <div style="display:flex; align-items:center; gap: 10px;">
                <el-button type="text" size="mini" @click="showHardDiskPurchaseInfo = !showHardDiskPurchaseInfo">
                  {{ showHardDiskPurchaseInfo ? '收起' : '展开' }}
                </el-button>
                <el-button type="success" size="mini" icon="el-icon-plus" @click="addHardDiskPurchaseItem"
                  :disabled="filterOptions('硬盘购买').length <= 0">
                  添加
                </el-button>
              </div>
            </div>
            <div v-show="showHardDiskPurchaseInfo" style="width: 100%!important; display:flex; flex-wrap:wrap;">
              <div v-if="formContract.hardDiskPurchaseInfo.length === 0"
                style="width:90%;padding:20px;text-align:center;color:#909399; border: 1px dashed #d9d9d9;border-top: none;">
                当前暂无硬盘选购信息，点击“添加”开始填写。
              </div>
              <div v-for="(purchase, index) in formContract.hardDiskPurchaseInfo" :key="index"
                style="width: 100%;display:flex;align-items: center;">
                <div
                  style="width: 90%;display:flex; flex-wrap:wrap; align-items:flex-start; gap:10px; padding-top: 20px; border: 1px dashed #d9d9d9;border-top: none;">
                  <el-form-item label="硬盘大小" :prop="'hardDiskPurchaseInfo.' + index + '.hardDiskSize'"
                    style="width: 32%!important;" :rules="[{ required: true, message: '请选择硬盘大小', trigger: 'change' }]">
                    <el-select v-model="purchase.hardDiskSize" placeholder="请选择硬盘大小" filterable>
                      <el-option v-for="item in filterOptions('硬盘购买', purchase.hardDiskSize)" :key="item.name"
                        :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="项目金额" :prop="'hardDiskPurchaseInfo.' + index + '.projectAmount'"
                    style="width: 32%!important;" :rules="[{ required: true, message: '请输入项目金额', trigger: 'change' },
                    { validator: validateHardDiskProjectAmount, trigger: 'change' }]">
                    <el-input v-model="purchase.projectAmount" auto-complete="off"
                      :disabled="formContract.contractType === 'DEVELOPMENT'" placeholder="请输入项目金额"></el-input>
                  </el-form-item>
                  <el-form-item label="数量" :prop="'hardDiskPurchaseInfo.' + index + '.sampleCount'"
                    style="width: 32%!important;" :rules="[{ required: true, message: '请输入选购数量', trigger: 'change' },
                    { validator: validateHardDiskSampleCount, trigger: 'change' }]">
                    <el-input style="width: 100%" v-model="purchase.sampleCount" auto-complete="off"
                      placeholder="请输入选购数量"></el-input>
                  </el-form-item>
                </div>
                <div
                  style="justify-content: center;display: flex;flex-wrap: wrap;margin-left: 10px;width: 50px;margin-right: 10px;">
                  <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHardDiskPurchaseItem(index)"
                    style="margin-bottom: 2px;"></el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formContract.contractType !== 'DEVELOPMENT'" style="width: 100%;">
          <el-form-item v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType)" label="补充分析要求"
            prop="analysisRequest">
            <div style="display: flex;align-items: center">
              <el-checkbox-group v-model="formContract.moreAnalysis" class="checkbox-group">
                <el-checkbox label="SENIOR_ANALYSIS">高级分析</el-checkbox>
                <el-checkbox label="CUSTOMIZED_ANALYSIS">个性化分析</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <div
            v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract?.moreAnalysis.includes('SENIOR_ANALYSIS')"
            style="display: flex;width: 100%">
            <el-form-item label="高级分析金额" prop="seniorAnalysisAmount" style="width: 35%!important;">
              <el-input v-model="formContract.seniorAnalysisAmount" auto-complete="off" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="高级分析附件" prop="seniorAnalysisFile">
              <div style="display:flex;width: 100%">
                <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                  :on-change="(...event) => { handleChange(event, 'senior') }" :file-list="seniorFileList"
                  :on-exceed="handleExceed" style="margin-top: 0;width: 100%">
                  <el-input style="width: 85%;" v-model="seniorFileName" readonly></el-input>
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div
            v-if="['预付款扣款（测序分析）', '测序分析'].includes(formContract.projectType) && formContract?.moreAnalysis.includes('CUSTOMIZED_ANALYSIS')"
            style="display: flex;width: 100%">
            <el-form-item label="个性化分析金额" prop="customizedAnalysisAmount" style="width: 35%!important;">
              <el-input v-model="formContract.customizedAnalysisAmount" auto-complete="off"
                placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="个性化分析附件" prop="customizedAnalysisFile">
              <div style="display:flex;width: 100%">
                <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                  :on-change="(...event) => { handleChange(event, 'customized') }" :file-list="customizedFileList"
                  :on-exceed="handleExceed" style="margin-top: 0;width: 100%">
                  <el-input style="width: 85%;" v-model="customizedFileName" readonly></el-input>
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </div>
        </div>
        <div style="display:flex;align-items: center;width: 100%" v-if="formContract.contractType !== 'DEVELOPMENT'
          && ['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款'].includes(formContract.projectType)">
          <div
            style="display:flex;flex-wrap: wrap;width: 90%!important;align-items: center;border: 1px dashed #d9d9d9;padding-top:20px;margin-bottom: 20px">
            <el-form-item label="核酸抽提" prop="extractionFlag" style="width: 48%!important;"
              v-if="formContract.projectType !== '预付款'">
              <el-select v-model="formContract.extractionFlag" placeholder="请选择是否进行核酸抽提" filterable>
                <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="抽提次数" prop="extractionNumber" style="width: 48%!important;"
              v-if="formContract.projectType !== '预付款' && formContract.extractionFlag === true">
              <el-input v-model="formContract.extractionNumber" placeholder="请输入抽提次数（正整数）"></el-input>
            </el-form-item>
            <el-form-item label="添加水印" prop="watermarkFlag" style="width: 48%!important;"
              v-if="companyIds.includes(Number(formContract.trusteeCompanyId))">
              <el-select v-model="formContract.watermarkFlag" placeholder="请选择是否添加水印" filterable>
                <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="付款方式" prop="methods" v-if="formContract.projectType !== '预付款'"
              :rules="{ required: true, message: '请选择付款方式', trigger: 'change' }" style="width: 48%!important;">
              <el-select v-model="formContract.methods" placeholder="请选择">
                <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="formContract.methods === 'TWO_PAYMENTS' && formContract.projectType !== '预付款'"
              prop="theFirstRatio" style="width: 48%!important;"
              :rules="[{ required: true, message: '请输入首付款比例', trigger: 'change' },
              { validator: (rule, value, callback) => checkMinMax(rule, value, callback, 0, 100), trigger: 'change' }]" label="首付款比例">
              <el-input placeholder="请输入首付款比例" v-model="formContract.theFirstRatio"><template
                  #append>%</template></el-input>
            </el-form-item>
          </div>
          <div style="display: flex;margin-bottom: 20px;flex-wrap: wrap;width: 10%!important;margin-right: 10px;">
            <el-button type="success" size="small" style="margin: 6px 10px 0 10px;"
              @click="openTemplate">生成合同</el-button>
            <el-button type="primary" size="small" style="margin: 6px 10px 0 10px;" @click="loadTemplate"
              :disabled="!templateFile">下载合同</el-button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCompanyPage } from "@/api/dilivery/company";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { check, checkDate, checkInclude, checkMinMax, checkNum, checkNumber, checkSize, checkSum, checkSumAmount, checkCharacter, checkTeamContractAmount } from "@/utils/rules";
import { formatNumberWithUnit, padDate } from "@/store/date";
import { getMaterialType } from "@/api/dilivery/material/lexicon";
import { getProjectList } from "@/api/dilivery/project";
import { getAllContract } from "@/api/dilivery/sales/contract";
import { copyText } from "@/utils/windowsUtils";
import { templateGeneration } from "@/api/dilivery/template";
import { fileDownload } from "@/utils/downFileUtils";
import { getConfigPage } from "@/api/dilivery/sysconfig";

export default {
  name: "AddNewTemplate",
  data() {
    return {
      gutSalesList: [],
      targetList: [
        "单细胞保护液",
        "微生态保护剂",
        "微生态保护液",
        "肠道菌群检测样本采集套装（16s全长）",
        "肠道菌群检测样本采集套装（宏基因组）",
        "RNA保护剂"
      ],
      specsOption: ['2ml', '5ml'],
      option: [{ label: '全款', value: 'FULL_AMOUNT' }, { label: '2次付款（首付款，尾款）', value: 'TWO_PAYMENTS' }],
      flagOption: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],
      isHandlingSpecificProjectType: false,
      isHandlingMaterials: false,
      seniorFileName: '',
      customizedFileName: '',
      contractFileName: '',
      AnalysisEvaluate: [],
      businessOption: [],
      ContactOptions: [],
      LexiconOptions: [],
      ProjectOption: [],
      contractLoading: false,
      TypeOption: [
        { label: 'NGS', name: '二代测序', disabled: [] },
        { label: 'AMPLICON', name: '扩增子测序', disabled: [] },
        { label: 'TGG', name: '三代测序', disabled: [] },
        { label: 'METAPRO', name: '蛋白代谢组测序', disabled: [] },
        { label: '硬盘购买', name: '硬盘购买', disabled: [] },
        { label: 'PCR', name: '其他', disabled: ['裸测', '预付款扣款（裸测）'] }
      ],
      userData: {},
      role: '',
      templateFile: null,
      contractFileList: [],
      seniorFileList: [],
      customizedFileList: [],
      showHardDiskPurchaseInfo: false,
      DateOptions: [
        { label: '1', name: '1年' },
      ],
      TypeOptions: [
        { label: 'PREPAYMENTS', name: '预付款' },
        { label: 'FORMAL', name: '正式' },
        { label: 'CHARGEBACKS', name: '扣款' },
        { label: 'DEVELOPMENT', name: '研发' },
        { label: 'TEAM', name: '团队费用' }
      ],
      formContract: {
        generateContractInfo: {
          extractionFlag: false,
          watermarkFlag: false,
          extractionNumber: '',
          returnSampleBo: {
            reason: '',
            returnSampleAmount: 0,
            returnSampleFlag: false
          },
          paymentMethods: {}
        },
        sampleManagement: null,
        watermarkFlag: false,
        extractionFlag: false,
        extractionNumber: '',
        returnSampleAmount: {},
        methods: 'FULL_AMOUNT',
        theFirstRatio: '',
        moreAnalysisRequest: {},
        returnFlag: false,
        sampleAmount: 0,
        reason: '',
        specificProjectType: [
          {
            dataAmountUnit: '',
            experimentalProcessItems: [],
            experimental: [],
            sequencingPlatform: '',
            sequencingPlatformType: '',
            sequencingPlatformList: [],
            projectSampleDataList: [],
            minSampleCount: '',
            maxSampleCount: '',
            projectMainTypeId: '',
            projectType: '',
            projectClassification: '',
            numberOfSamples: 0,
            projectAmount: 0,
            sizeOfSampleData: {},
            projectList: [],
            analysisList: [],
            analysis: '标准分析',
            multipleChoice: false,
            analysisChoiceList: [],
            labList: [],
            analyzeRequirements: ''
          }
        ],
        moreAnalysis: [],
        analysisRequest: 'STANDARD_ANALYSIS',
        materials: [
          {
            materialId: '',
            materialNumber: '',
            remainingNumber: '',
            specs: ''
          }
        ],
        protectiveFluidInfo: {
          protectiveFluidMethod: '',
          doorInfo: {
            doorTime: '',
            doorFee: '',
            phone: '',
            address: ''
          },
          materialMailInfo: {
            mailTime: '',
            recipient: '',
            phone: '',
            address: ''
          }
        },
        hardDiskPurchaseInfo: [],
        pureAnalysisInfo: {
          pureAnalysisType: '',
          contracts: [
            {
              contractId: '',
              projectIds: [],
              options: []
            }
          ]
        },
        pureAnalysisEvaluateId: '',
        seniorAnalysisFile: null,
        customizedAnalysisFile: null,
        seniorAnalysisAmount: 0,
        customizedAnalysisAmount: 0,
        expirationDate: '1',
        contractType: 'FORMAL',
        contractDraftingDate: '',
        contractAmount: 0,
        salesId: '',
        customerContactsId: '',
        addedAmount: 0,
        signingPlace: '上海',
        remainingAmount: 0,
        contractNumber: 'BZ20250101000001',
        contractName: '',
        trusteeCompanyId: '1',
        trusteeContactsId: '',
        projectType: '测序分析',
        remark: ''
      },
      rulesContract: {
        contractDraftingDate: [
          { required: true, message: '请选择合同拟定时间', trigger: 'change' },
          { validator: checkDate, trigger: 'change' }
        ],
        salesId: [
          { required: true, message: '请选择销售', trigger: 'change' }
        ],
        contractType: [
          { required: true, message: '请选择合同分类', trigger: 'change' }
        ],
        projectType: [
          { required: true, message: '请选择合同类型', trigger: 'change' }
        ],
        contractAmount: [
          { required: true, message: '请输入合同金额', trigger: 'change' },
          { validator: checkNumber, trigger: 'change' }
        ],
        addedAmount: [
          { required: true, message: '请输入增值金额', trigger: 'change' },
          { validator: checkNumber, trigger: 'change' }
        ],
        contractNumber: [
          { required: true, message: '请获取合同编号', trigger: 'change' }
        ],
        contractName: [
          { required: true, message: '请输入合同名称', trigger: 'change' },
          { validator: checkCharacter, trigger: 'change' }
        ],
        sampleManagement: [
          { required: true, message: '请选择样品处理方式', trigger: 'change' }
        ],
        signingPlace: [
          { required: true, message: '请输入签订地点', trigger: 'change' }
        ],
        expirationDate: [
          { required: true, message: '请选择有效期限', trigger: 'change' }
        ],
        customerContactsId: [
          { required: true, message: '请选择甲方联系人', trigger: 'change' }
        ],
        trusteeCompanyId: [
          { required: true, message: '请选择乙方(受托方)', trigger: 'change' }
        ],
        trusteeContactsId: [
          { required: true, message: '请选择乙方联系人', trigger: 'change' }
        ],
        // pureAnalysisEvaluateId: [
        //   { required: true, message: '请选择纯分析评估人', trigger: 'change' }
        // ],
        analysisRequest: [
          { required: false, message: '请选择分析要求', trigger: 'change' }
        ],
        seniorAnalysisFile: [
          { required: true, message: '请上传高级分析附件', trigger: 'change' }
        ],
        customizedAnalysisFile: [
          { required: true, message: '请上传个性化分析附件', trigger: 'change' }
        ],
        customizedAnalysisAmount: [
          { required: true, message: '请输入个性化分析金额', trigger: 'change' },
          { validator: checkNumber, trigger: 'change' }
        ],
        seniorAnalysisAmount: [
          { required: true, message: '请输入高级分析金额', trigger: 'change' },
          { validator: checkNumber, trigger: 'change' }
        ],
        returnFlag: [
          { required: true, message: '请选择是否返样', trigger: 'change' },
        ],
        sampleAmount: [
          { required: true, message: '请输入服务费(返样)', trigger: 'change' },
          { validator: checkNumber, trigger: 'change' }
        ],
        extractionFlag: [
          { required: true, message: '请选择是否进行核酸抽提', trigger: 'change' },
        ],
        watermarkFlag: [
          { required: true, message: '请选择是否添加水印', trigger: 'change' },
        ],
        extractionNumber: [
          {
            // 仅当 extractionFlag 为 true 时校验为正整数
            validator: (rule, value, callback) => {
              try {
                if (!this.formContract.extractionFlag) {
                  return callback(); // 不需要校验
                }
                if (value === '' || value === null || value === undefined) {
                  return callback(new Error('请输入抽提次数'));
                }
                const n = Number(value);
                if (!Number.isInteger(n) || n <= 0) {
                  return callback(new Error('抽提次数必须为正整数'));
                }
                return callback();
              } catch (e) {
                return callback(new Error('抽提次数校验失败'));
              }
            },
            trigger: 'change'
          }
        ],
        reason: [
          { required: true, message: '请填写服务费(返样)为0的原因', trigger: 'change' },
        ]
      },
    }
  },
  computed: {
    companyIds() {
      return this.businessOption.filter(item => item.companyName.includes('凌恩')).map(item => Number(item.id))
    },
    projectTypeList() {
      return this.formContract.specificProjectType.map(item => item.projectType)
    },
    materialNumber() {
      return this.formContract.materials.reduce((acc, item) => {
        if (!acc[item.materialId]) {
          acc[item.materialId] = 0; // 初始化该 id 的总和
        }
        acc[item.materialId] += item.materialNumber; // 累加 number
        return acc;
      }, {});
    },
    maxAmount() {
      return this.formContract.specificProjectType.map(item => {
        const amount = Number(item.projectAmount); // 将可能的字符串形式转换为数字
        return amount > 0 ? amount : 0; // 如果为大于0的数字，返回自身，否则返回0
      }).reduce((sum, amount) => sum + amount, 0)
    },
    selectValue() {
      const countMap = new Map();
      this.formContract.materials.map(item => item.materialId).forEach(item => {
        if (countMap.has(item)) {
          countMap.set(item, countMap.get(item) + 1);
        } else {
          countMap.set(item, 1);
        }
      });
      const result = [];
      countMap.forEach((count, item) => {
        if (count === this.specsOption.length) {
          result.push(item);
        }
      });
      return result;
    },
    projectTypeData() {
      return ['测序分析', '裸测', '预付款扣款（测序分析）', '预付款扣款（裸测）',]
    },
    pureAnalysisTypeOptions() {
      // 与后端 pureAnalysisType 枚举保持一致
      return [
        { value: 'AFTER_SALES_ANALYSIS', label: '售后分析' },
        { value: 'RAW_DATA_RERELEASE', label: '原始数据重释放' },
        { value: 'PURE_ANALYSIS', label: '纯分析' }
      ]
    },
    //纯分析类型对应的合同查询类型（售后分析→已分析完成合同；原始数据重释放→已释放原始数据合同）
    pureAnalysisContractType() {
      const type = this.formContract.pureAnalysisInfo?.pureAnalysisType
      if (type === 'AFTER_SALES_ANALYSIS') return 'ANALYSIS_OVER_CONTRACT'
      if (type === 'RAW_DATA_RERELEASE') return 'RELEASED_RAW_DATA_CONTRACT'
      return ''
    },
    hardDiskList() {
      return ['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款扣款（纯分析）', '纯分析', '预付款扣款（返样/暂存样品）', '返样/暂存样品', '预付款扣款（其他）', '其他']
    },
    // AnalysisEvaluateOptions() {
    //   if (this.formContract.contractType === 'DEVELOPMENT') {
    //     return this.AnalysisEvaluate.filter(item => item.name === '程燕')
    //   } else {
    //     return this.AnalysisEvaluate
    //   }
    // },
    DirectionOptions() {
      const directions = [
        
        { label: '微生态保护剂', check: true },
        { label: '肠道菌群检测样本采集套装（16s全长）', check: false },
        { label: '肠道菌群检测样本采集套装（宏基因组）', check: false },
        { label: 'RNA保护剂', check: true },
      ].filter(item => this.userData.personUuids.some(it => this.gutSalesList.includes(it)) || this.role === 'ADMIN' || item.check);
      if (this.targetList.includes(this.formContract.projectType) && !directions.find(item => item.label === this.formContract.projectType)) {
        this.formContract.projectType = '' // 如果当前项目类型不在筛选后的列表中，重置项目类型
      }
      if (this.formContract.contractType === 'PREPAYMENTS') {
        return [
          { label: '预付款' },
        ]
      } else if (['FORMAL'].includes(this.formContract.contractType)) {
        return [
          { label: '测序分析' },
          { label: '裸测' },
          { label: '纯分析' },
          { label: '返样/暂存样品' },
          ...directions,
          { label: '数据库、服务器、系统流程开发和部署' },
          { label: '培训服务' },
          { label: '其他' }
        ]
      } else if (this.formContract.contractType === 'CHARGEBACKS') {
        return [
          { label: '预付款扣款（测序分析）' },
          { label: '预付款扣款（裸测）' },
          { label: '预付款扣款（纯分析）' },
          { label: '预付款扣款（返样/暂存样品）' },
          ...directions,
          { label: '预付款扣款（数据库、服务器、系统流程开发和部署）' },
          { label: '预付款扣款（培训服务）' },
          { label: '预付款扣款（其他）' },
        ]
      } else if (this.formContract.contractType === 'DEVELOPMENT') {
        return [
          { label: '测序分析' },
          ...directions,
          { label: '纯分析' },
          { label: '裸测' },
        ]
      } else if (this.formContract.contractType === 'TEAM') {
        return [
          { label: '裸测' },
          { label: '测序分析' },
          { label: '纯分析' },
        ]
      } else {
        return []
      }
    },
  },
  watch: {
    // 监听解离投递方式，若为邮寄且存在解离项目则自动添加单细胞保护液物料
    'formContract.protectiveFluidInfo.protectiveFluidMethod': {
      handler(newVal) {
        const dissociationTypes = ['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'];
        const hasDissociation = this.formContract.specificProjectType.some(p => dissociationTypes.includes(p.projectType));
        if (hasDissociation && newVal === 'MAIL') {
          // 检查物料中是否已有单细胞保护液
          const exists = this.formContract.materials.some(m => {
            const mat = this.LexiconOptions.find(l => l.id === m.materialId);
            return mat && mat.materialName === '单细胞保护液';
          });
          if (!exists) {
            // 查找物料字典中的单细胞保护液
            const option = this.LexiconOptions.find(l => l.materialName === '单细胞保护液');
            if (option) {
              this.formContract.materials = [{
                materialId: option.id,
                materialNumber: '',
                remainingNumber: option.number,
                specs: ''
              }]
            }
          }
        }
      },
      immediate: true
    },
    'formContract.materials': {
      handler(newVal) {
        if (this.isHandlingMaterials) return; // 如果正在处理，直接返回
        this.isHandlingMaterials = true; // 标记正在处理
        if (!Array.isArray(newVal) || newVal.length <= 0) {
          this.$set(this.formContract, 'materials', [
            {
              materialId: '',
              materialNumber: '',
              remainingNumber: '',
              specs: ''
            }
          ]);
        }
        if (Array.isArray(newVal)) {
          newVal.forEach((item, index) => {
            const material = this.LexiconOptions.find(itemA => itemA.id === item.materialId);
            if (material) {
              this.$set(this.formContract.materials[index], 'remainingNumber', material.number);
            }
          });
        }
        this.isHandlingMaterials = false; // 处理完毕，取消标记
      },
      immediate: true,
      deep: true
    },
    'formContract.projectType': {
      handler(newVal) {
        if (this.targetList.includes(newVal)) {
          const material = this.LexiconOptions.find(item => item.materialName === newVal);
          if (material) {
            this.formContract.materials = [{ materialId: material.id, materialNumber: '', remainingNumber: '', specs: '' }];
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
  },
  mounted() {
    this.getGutSales()
    this.getBusinessOption();
    // this.getAnalysisEvaluate()
    this.getLexiconOptions()
    this.getProjectOption()
    if (this.formContract.contractDraftingDate === '') {
      this.formContract.contractDraftingDate = this.getCurrentDate('sign')
    }
  },
  methods: {
    checkNum,
    checkSumAmount,
    checkSum,
    checkInclude,
    checkMinMax,
    check,
    checkSize,
    checkNumber,
    getGutSales() {
      getConfigPage({}, {}).then(res => {
        this.gutSalesList = []
        if (res.code === 200) {
          const form = res.data.records.find(item => item.name === 'SYS_CONTRACT_GUT_SALES')
          if (form) {
            this.gutSalesList = form.confValue.split(',')
          }
        }
      }).catch(() => {
        this.gutSalesList = []
      })
    },
    //获取所有的项目类型
    async getProjectOption() {
      try {
        const res = await getProjectList({})
        if (res.code === 200) {
          this.ProjectOption = res.data.filter(item => !item.deprecated)
        }
      } catch (error) { console.log(error); }
    },
    //获取已执行合同列表（供纯分析项目选择使用，支持初始加载 + 合同编号远程搜索，按组存储选项）
    async getEnforceContractOption(query, index) {
      const contractType = this.pureAnalysisContractType
      if (!contractType) return
      const group = this.formContract.pureAnalysisInfo.contracts[index]
      if (!group) return
      try {
        this.contractLoading = true
        const data = {}
        if (query) {
          // 合同编号前缀存在 BZ / BZD / BZF 等多种字母形式，搜索时统一去除字母前缀，只按数字后缀模糊匹配
          const normalizedQuery = String(query).replace(/^[A-Za-z]+/, '').trim()
          if (normalizedQuery) {
            data['query#contractNumber.LIKE'] = normalizedQuery
          }
        }
        const res = await getAllContract(contractType, data)
        if (res.code === 200) {
          let list = res.data || []
          // 保留当前组已选中的合同，避免搜索后选项被覆盖导致 label / specificProjectType 丢失
          const selectedId = group.contractId
          if (selectedId && !list.some(item => String(item.id) === String(selectedId))) {
            const cached = (group.options || []).find(item => String(item.id) === String(selectedId))
            if (cached) {
              list = [cached, ...list]
            }
          }
          this.$set(group, 'options', list)
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.contractLoading = false
      }
    },
    //纯分析类型变更时重置合同组并按需加载「合同」下拉初始选项
    changePureAnalysisType(type) {
      this.formContract.pureAnalysisInfo.contracts = [{ contractId: '', projectIds: [], options: [] }]
      if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(type)) {
        // 售后分析/原始数据重释放均需先选合同，按类型加载对应合同列表
        this.getEnforceContractOption('', 0)
      }
    },
    //纯分析项目选择 - 合同变更时重置该组项目
    changePureAnalysisContract(index) {
      const group = this.formContract.pureAnalysisInfo.contracts[index]
      if (group) {
        group.projectIds = []
      }
    },
    //纯分析项目选择 - 新增一组合同+项目
    addPureAnalysisContract() {
      this.formContract.pureAnalysisInfo.contracts.push({ contractId: '', projectIds: [], options: [] })
      const newIndex = this.formContract.pureAnalysisInfo.contracts.length - 1
      if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(this.formContract.pureAnalysisInfo.pureAnalysisType)) {
        this.getEnforceContractOption('', newIndex)
      }
    },
    //纯分析项目选择 - 删除指定组
    removePureAnalysisContract(index) {
      if (this.formContract.pureAnalysisInfo.contracts.length <= 1) return
      this.formContract.pureAnalysisInfo.contracts.splice(index, 1)
    },
    //合同去重：已被其他组选中的合同在当前组下拉中禁用，保证每个合同仅能选择一次
    isContractOptionDisabled(contractId, index) {
      if (!contractId) return false
      const contracts = this.formContract.pureAnalysisInfo.contracts || []
      return contracts.some((c, i) => i !== index && String(c.contractId) === String(contractId))
    },
    //提交兜底校验：团队费用合同金额上限（测序分析 800 / 纯分析 1500）
    validateTeamContractAmount() {
      const error = checkTeamContractAmount(this.formContract, this.formContract.contractAmount)
      return error ? { valid: false, message: error } : { valid: true }
    },
    //提交兜底校验：纯分析多组合同不允许重复选择同一合同（防止异常操作绕过 UI 禁用）
    validatePureAnalysisContracts() {
      if (this.formContract.contractType !== 'TEAM' || this.formContract.projectType !== '纯分析') {
        return { valid: true }
      }
      const info = this.formContract.pureAnalysisInfo
      if (!info || !['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(info.pureAnalysisType)) {
        return { valid: true }
      }
      const contracts = Array.isArray(info.contracts) ? info.contracts : []
      const ids = contracts.map(c => c.contractId).filter(Boolean).map(id => String(id))
      const duplicated = ids.some((id, i) => ids.indexOf(id) !== i)
      if (duplicated) {
        return { valid: false, message: '纯分析项目选择中存在重复的合同，请确保每个合同仅选择一次' }
      }
      return { valid: true }
    },
    //根据指定组已选合同解析项目下拉选项
    getProjectOptions(group) {
      if (!group || !group.contractId) return []
      const contract = (group.options || []).find(item => String(item.id) === String(group.contractId))
      return (contract?.specificProjectType || []).map(item => ({
        id: item.projectMainTypeId,
        label: item.projectClassification + '-' + item.projectType
      }))
    },
    changeAnalysisChoice(value, project) {
      if (value.includes('normal') && value.includes('binning')) {
        const last = value.slice(-1)[0];
        const index = this.formContract.specificProjectType.indexOf(project)
        let val = value.filter(item => !['normal', 'binning'].includes(item))
        val.push(last)
        this.$set(this.formContract.specificProjectType[index], 'analysisList', val)
      }
    },

    changeProjectType() {
      const list = this.TypeOption.filter(item => item.disabled.includes(this.formContract.projectType)).map(item => item.label)
      this.formContract.specificProjectType = this.formContract.specificProjectType.filter(item => !list.includes(item.projectClassification))
      if (this.formContract.specificProjectType.length === 0) {
        this.handleAddProject()
      }
    },
    returnList(keys, data) {
      const order = ['NGS', 'PACBIO', 'HIC', 'ONT'];
      return Object.entries(keys).map(([key, value]) => {
        let name;
        switch (key) {
          case "NGS":
            name = "二代";
            break;
          case "PACBIO":
            name = "三代";
            break;
          case "HIC":
            name = "HIC";
            break;
          case "ONT":
            name = "ONT";
            break;
          default:
            name = ""; // 如果 key 不在预定义的列表中，name 为空字符串
        }
        return {
          key: key,
          value: value,
          size: data ? formatNumberWithUnit(Number(data[key])) : "",
          boolean: value !== "NOT",
          name: name // 添加 name 属性
        };
      }).sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
    },
    getSizeList(type, name, sizeOfSampleData) {
      if (type === '' || name === '') {
        return []
      }
      if (sizeOfSampleData) {
        return this.returnList(sizeOfSampleData, sizeOfSampleData)
      }
      const project = this.ProjectOption.find(item => item.model === type && item.name === name)
      if (project && project['geneSequencingSetting']) {
        return this.returnList(project['geneSequencingSetting'], sizeOfSampleData)
      } else {
        return []
      }
    },
    filterOption(value) {
      let options = this.LexiconOptions.filter(item => item.materialName === this.formContract.projectType)
      if (value && value !== '') {
        return options.filter(item => !this.selectValue.includes(item.id) || item.id === value)
      }
      return options.filter(item => !this.selectValue.includes(item.id))
    },
    filterSpecsOption(value, specs) {
      if (value && value !== '') {
        return this.specsOption.filter(item => !this.formContract.materials.filter(item => item.materialId === value).map(item => item.specs).includes(item) || item === specs)
      }
      return JSON.parse(JSON.stringify(this.specsOption))
    },
    createName() {
      let nameLast = ''
      if (this.projectTypeData.includes(this.formContract.projectType)) {
        for (let project of this.formContract.specificProjectType) {
          if (['硬盘购买', 'PCR'].includes(project.projectClassification)) {
            continue
          }
          let sum = 0
          for (let data of project.projectSampleDataList) {
            sum = sum + Number(data.numberOfSamples)
          }
          nameLast = nameLast + sum + '个' + '-' + project.projectType + '-'
        }
      }
      const name = ['测序分析', '裸测', '纯分析'].find(item => this.formContract.projectType.includes(item))
      this.formContract.contractName = nameLast + (name ? name : '')
    },
    filterOptions(type, project) {
      const HARD_DISK_OPTIONS = [
        { model: '硬盘购买', name: '1T', deprecated: false },
        { model: '硬盘购买', name: '2T', deprecated: false },
        { model: '硬盘购买', name: '4T', deprecated: false },
        { model: '硬盘购买', name: '5T', deprecated: false },
        { model: '硬盘购买', name: '6T', deprecated: false },
        { model: '硬盘购买', name: '8T', deprecated: false },
        { model: '硬盘购买', name: '10T', deprecated: false },
        { model: '硬盘购买', name: '12T', deprecated: false },
        { model: '硬盘购买', name: '16T', deprecated: false },
        { model: '硬盘购买', name: '20T', deprecated: false }
      ];
      if (!type) {
        return [];
      }
      const options = type === '硬盘购买' ? HARD_DISK_OPTIONS : this.ProjectOption;
      const filterCondition = (item) => {
        if (this.formContract.contractType === 'TEAM' && type === 'PCR' && item.name === '理化性质') {
          return false;
        }
        return item.model === type && (!this.projectTypeList.includes(item.name) || (project && item.name === project));
      };
      return options.filter(filterCondition);
    },
    addHardDiskPurchaseItem() {
      if (!Array.isArray(this.formContract.hardDiskPurchaseInfo)) {
        this.formContract.hardDiskPurchaseInfo = []
      }
      const options = this.filterOptions('硬盘购买')
      const selectedSizes = this.formContract.hardDiskPurchaseInfo.map(entry => entry.hardDiskSize).filter(size => size)
      const nextOption = options.find(opt => !selectedSizes.includes(opt.name))
      this.formContract.hardDiskPurchaseInfo.push({
        hardDiskSize: nextOption ? nextOption.name : '',
        projectAmount: 0,
        sampleCount: 0
      })
      this.showHardDiskPurchaseInfo = true
    },
    removeHardDiskPurchaseItem(index) {
      if (!Array.isArray(this.formContract.hardDiskPurchaseInfo)) {
        return
      }
      this.formContract.hardDiskPurchaseInfo.splice(index, 1)
    },
    validateHardDiskProjectAmount(rule, value, callback) {
      if (this.formContract.contractType === 'DEVELOPMENT') {
        return callback()
      }
      if (value === '' || value === null || value === undefined) {
        return callback()
      }
      const number = Number(value)
      if (!isNaN(number) && number >= 0) {
        return callback()
      }
      callback(new Error('请输入大于等于0的数字'))
    },
    validateHardDiskSampleCount(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        return callback()
      }
      const str = String(value).trim()
      const number = Number(value)
      if (/^\d+$/.test(str) && !isNaN(number) && number > 0) {
        return callback()
      }
      callback(new Error('请输入大于等于0的整数'))
    },
    async changeNumber(id, index) {
      if (this.LexiconOptions.length === 0) {
        await this.getLexiconOptions()
      }

      this.formContract.materials[index].remainingNumber = this.LexiconOptions.find(item => item.id === id).number
      this.formContract.materials[index].specs = ''
    },
    async getLexiconOptions() {
      try {
        let param = {
          'type': 'PROTECT_REAGENT'
        }
        const res = await getMaterialType(param)
        if (res.code === 200) {
          this.LexiconOptions = res.data.filter(item => item.number !== 0 && item['materialStatus'])
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeContractType(type) {
      this.rulesContract.contractAmount = [
        { required: true, message: '请输入合同金额', trigger: 'change' },
        { validator: checkNumber, trigger: 'change' }
      ]
      if (type) {
        if (type === 'PREPAYMENTS') {
          this.formContract.projectType = '预付款'

        } else if (type === 'CHARGEBACKS') {
          this.formContract.projectType = '预付款扣款（测序分析）'

          this.formContract.addedAmount = 0
        } else if (type === 'FORMAL') {
          this.formContract.projectType = '测序分析'

          this.formContract.addedAmount = 0
        } else if (type === 'DEVELOPMENT') {
          this.formContract.contractAmount = 0
          this.formContract.projectType = '测序分析'
          this.formContract.addedAmount = 0
          this.rulesContract.contractAmount = [
            { required: true, message: '请输入合同金额', trigger: 'change' },
          ]
          this.formContract.specificProjectType.forEach((item, index) => {
            this.$set(item, 'projectAmount', 0);
          })
          if (Array.isArray(this.formContract.hardDiskPurchaseInfo)) {
            this.formContract.hardDiskPurchaseInfo.forEach(item => {
              item.projectAmount = 0
            })
          }
        } else if (type === 'TEAM') {
          this.formContract.projectType = '测序分析'
          this.formContract.addedAmount = 0
        }
      }
    },
    addProjectAmount(value, index) {
      let num = 0
      let list = this.formContract.specificProjectType[index].experimental.filter(item => this.formContract.specificProjectType[index].labList.includes(item.experimentName))
      for (let data of list) {
        const number = data.experimentAmount
        num = num + Number(number ? number : 0)
      }
      this.formContract.specificProjectType[index].projectAmount = num
    },
    handleAddProject() {
      if (!Array.isArray(this.formContract.specificProjectType)) {
        this.$set(this.formContract, 'specificProjectType', [])
      }
      let project = {
        experimentalProcessItems: [],
        experimental: [],
        sequencingPlatform: '',
        sequencingPlatformType: '',
        sequencingPlatformList: [],
        projectSampleDataList: [],
        minSampleCount: '',
        maxSampleCount: '',
        projectMainTypeId: '',
        projectType: '',
        projectClassification: '',
        numberOfSamples: 0,
        projectAmount: 0,
        sizeOfSampleData: {},
        projectList: [],
        analysisList: [],
        analysis: '标准分析',
        multipleChoice: false,
        analysisChoiceList: [],
        labList: [],
        analyzeRequirements: ''
      }
      this.formContract.specificProjectType.push(project)
    },
    handleAddData(index) {
      let data = {
        numberOfSamples: 0,
        sizeOfSampleData: {},
        projectList: JSON.parse(JSON.stringify(this.formContract.specificProjectType[index].projectList))
      }
      this.formContract.specificProjectType[index].projectSampleDataList.push(data)
    },
    handleDeleteData(index, sonIndex) {
      this.formContract.specificProjectType[index].projectSampleDataList.splice(sonIndex, 1)
      if (this.formContract.specificProjectType[index].projectSampleDataList.length === 0) {
        this.handleAddData(index)
      }
    },
    handleAddMaterial() {
      let material = {
        materialId: '',
        materialNumber: '',
        remainingNumber: '',
        specs: ''
      }
      this.formContract.materials.push(material)
    },
    handleDeleteProject(item) {
      const index = this.formContract.specificProjectType.indexOf(item)
      if (index !== -1) {
        this.formContract.specificProjectType.splice(index, 1)
      }
      if (this.formContract.specificProjectType.length === 0) {
        this.handleAddProject()
      }
    },
    handleDeleteMaterial(item) {
      const index = this.formContract.materials.indexOf(item)
      if (index !== -1) {
        this.formContract.materials.splice(index, 1)
      }
      if (this.formContract.materials.length === 0) {
        this.handleAddMaterial()
      }
    },
    changeProject(item) {
      const index = this.formContract.specificProjectType.indexOf(item)
      if (index !== -1) {
        this.$set(this.formContract.specificProjectType[index], 'dataAmountUnit', '');
        this.$set(this.formContract.specificProjectType[index], 'projectMainTypeId', '');
        this.$set(this.formContract.specificProjectType[index], 'projectType', '');
        this.$set(this.formContract.specificProjectType[index], 'projectList', []);
        this.$set(this.formContract.specificProjectType[index], 'projectSampleDataList', []);
        this.$set(this.formContract.specificProjectType[index], 'minSampleCount', '');
        this.$set(this.formContract.specificProjectType[index], 'maxSampleCount', '');
        this.$set(this.formContract.specificProjectType[index], 'multipleChoice', false);
        this.$set(this.formContract.specificProjectType[index], 'analysisList', []);
        this.$set(this.formContract.specificProjectType[index], 'analysisChoiceList', []);
        this.$set(this.formContract.specificProjectType[index], 'experimental', []);
        this.$set(this.formContract.specificProjectType[index], 'experimentalProcessItems', []);
        this.$set(this.formContract.specificProjectType[index], 'labList', []);
        this.$set(this.formContract.specificProjectType[index], 'sequencingPlatform', '');
        this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformType', '');
        this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformList', []);
      }
    },
    changeType(item) {
      const index = this.formContract.specificProjectType.indexOf(item)
      if (index !== -1) {
        this.$set(this.formContract.specificProjectType[index], 'projectList', this.getSizeList(item.projectClassification, item.projectType))
        this.$set(item, 'projectSampleDataList', [])
        this.$set(item, 'experimentalProcessItems', []);
        this.$set(item, 'dataAmountUnit', '');
        this.$set(item, 'projectMainTypeId', '');
        this.$set(item, 'minSampleCount', '');
        this.$set(item, 'maxSampleCount', '');
        this.$set(item, 'multipleChoice', false);
        this.$set(item, 'analysisList', []);
        this.$set(item, 'analysisChoiceList', []);
        this.$set(item, 'experimental', []);
        this.$set(item, 'labList', []);
        this.$set(item, 'sequencingPlatform', '');
        this.$set(item, 'sequencingPlatformList', []);
        this.$set(item, 'thirdSequencingPlatform', '');
        this.$set(item, 'tesThirdSequencingPlatform', '');
        this.$set(item, 'thirdSequencingPlatformList', []);
        this.handleAddData(index)
        const project = this.ProjectOption.find(itemA => itemA.name === item.projectType);
        if (project) {
          this.$set(this.formContract.specificProjectType[index], 'dataAmountUnit', project.attribute.dataAmountUnit ? project.attribute.dataAmountUnit : '');
          this.$set(this.formContract.specificProjectType[index], 'projectMainTypeId', project.id);
          this.$set(this.formContract.specificProjectType[index], 'minSampleCount', project.attribute.minSampleCount);
          this.$set(this.formContract.specificProjectType[index], 'maxSampleCount', project.attribute.maxSampleCount);
          this.$set(this.formContract.specificProjectType[index], 'multipleChoice', project.attribute.multipleChoice);
          this.$set(this.formContract.specificProjectType[index], 'analysisList', []);
          this.$set(this.formContract.specificProjectType[index], 'analysisChoiceList', project.attribute.optionalAnalysisType.split('/')?.filter(item => item !== '') ?? []);
          if (project.attribute.labProcess) {
            let list = project.attribute.labProcess.split('/')?.filter(item => item !== '') ?? []
            for (let items of ['引物合成', '荧光定量']) {
              const index1 = list.indexOf(items)
              if (index1 !== -1) {
                list.splice(index1, 1)
                list.unshift(items)
              }
            }

            let experimental = []
            for (let info of list) {
              let lab = {
                experimentName: info,
                numberOfExperiment: '',
                experimentAmount: ''
              }
              experimental.push(lab)
            }
            this.$set(this.formContract.specificProjectType[index], 'experimental', experimental);
          } else {
            this.$set(this.formContract.specificProjectType[index], 'experimental', []);
          }
          this.$set(this.formContract.specificProjectType[index], 'labList', []);
          for (let items of ['引物合成', '荧光定量']) {
            if (this.formContract.specificProjectType[index].experimental.map(item => item.experimentName).includes(items)) {
              this.formContract.specificProjectType[index].labList.push(items)
            }
          }

          if (project.attribute.sequencingPlatform && item.projectClassification !== '其他') {
            this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformList', project.attribute.sequencingPlatform.split('/')?.filter(item => item !== '') ?? []);
            if (project.attribute.sequencingPlatform) {
              this.$set(this.formContract.specificProjectType[index], 'sequencingPlatform', (project.attribute.sequencingPlatform.split('/')?.filter(item => item !== '') ?? [])[0]);
            }
            if (item.projectClassification === 'AMPLICON') {
              switch (project?.modelAttr?.sonModel) {
                case 'SECOND':
                  this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformType', '二代');
                  break
                case 'THIRD':
                  this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformType', '三代');
                  break
                default:
                  this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformType', '');
                  break
              }
            } else {
              if (this.formContract.specificProjectType[index].sequencingPlatformList.length > 1) {
                this.$set(item, 'sequencingPlatformType', '二代');
              } else if (this.formContract.specificProjectType[index].sequencingPlatformList.length === 1) {
                this.$set(item, 'sequencingPlatformType', '三代');
              } else {
                this.$set(item, 'sequencingPlatformType', '');
              }
            }
          } else {
            this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformList', []);
            this.$set(this.formContract.specificProjectType[index], 'sequencingPlatformType', '');
          }
        }
      }
    },
    getBusinessOption() {
      try {
        let params = {
          'page.current': 1,
          'page.size': 500,
          'order': 'id.asc'
        }
        getCompanyPage(params, {}).then(res => {
          if (res.code === 200) {
            this.businessOption = res.data.records.filter(item => item['companyInvoiceStatus'])
            if (!this.businessOption.find(item => item.id === this.formContract.trusteeCompanyId)) {
              this.formContract.trusteeCompanyId = this.businessOption[0].id
            }
          }
        }).catch(err => { })
      } catch (error) {
        console.log(error);
        this.$messageUi.error('获取开票单位信息失败');
      }
    },
    validateForm(ref) {
      return new Promise((resolve) => {
        this.$refs[ref]['validate']((valid) => {
          resolve(valid);
        });
      });
    },
    addAllAmount() {
      const maxAmount = Number(this.maxAmount)
      const sampleAmount = (['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(this.formContract.projectType) && this.formContract.returnFlag && this.formContract.contractType !== 'DEVELOPMENT') ? Number(this.formContract.sampleAmount) : 0
      const seniorAnalysisAmount = this.formContract.moreAnalysis.includes('SENIOR_ANALYSIS') ? Number(this.formContract.seniorAnalysisAmount) : 0
      const customizedAnalysisAmount = this.formContract.moreAnalysis.includes('CUSTOMIZED_ANALYSIS') ? Number(this.formContract.customizedAnalysisAmount) : 0
      if (this.projectTypeData.includes(this.formContract.projectType) && this.formContract.contractType !== 'DEVELOPMENT') {
        if (['预付款扣款（测序分析）', '测序分析'].includes(this.formContract.projectType)) {
          this.formContract.contractAmount = seniorAnalysisAmount + customizedAnalysisAmount + maxAmount + sampleAmount
        } else {
          this.formContract.contractAmount = maxAmount + sampleAmount
        }
      }
    },
    // 构建合同提交数据（公共逻辑）
    buildContractPayload(formContract) {
      const result = JSON.parse(JSON.stringify(formContract))

      // 水印
      if (!this.companyIds.includes(Number(result.trusteeCompanyId))) {
        result.watermarkFlag = false
      }

      // 日期格式化
      result.contractDraftingDate = padDate(result.contractDraftingDate)

      // 补充分析要求
      if (['预付款扣款（测序分析）', '测序分析'].includes(result.projectType) && result.contractType !== 'DEVELOPMENT') {
        result.moreAnalysisRequest = result.moreAnalysis.reduce((acc, item) => {
          if (item === 'SENIOR_ANALYSIS') {
            acc[item] = result.seniorAnalysisAmount
          } else if (item === 'CUSTOMIZED_ANALYSIS') {
            acc[item] = result.customizedAnalysisAmount
          }
          return acc
        }, {})
      } else {
        result.moreAnalysisRequest = {}
        result.analysisRequest = null
      }

      // 生成合同信息
      if (['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测', '预付款'].includes(result.projectType)) {
        if (result.methods === 'FULL_AMOUNT') {
          result.generateContractInfo.paymentMethods = { [result.methods]: 1 }
        } else {
          result.generateContractInfo.paymentMethods = { [result.methods]: Number(result.theFirstRatio) / 100 }
        }
        let returnSample = {}
        if (['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(result.projectType) && result.contractType !== 'DEVELOPMENT') {
          returnSample.returnSampleFlag = result.returnFlag
          returnSample.returnSampleAmount = result.returnFlag ? result.sampleAmount : 0
          returnSample.reason = result.returnFlag && Number(result.sampleAmount) === 0 ? result.reason : ''
        }
        result.generateContractInfo.returnSampleBo = returnSample
        result.generateContractInfo.extractionFlag = result.extractionFlag
        result.generateContractInfo.extractionNumber = result.extractionNumber
        result.generateContractInfo.watermarkFlag = result.watermarkFlag
      } else {
        result.generateContractInfo.paymentMethods = {}
        result.generateContractInfo.returnSampleBo = {}
        result.generateContractInfo.extractionFlag = false
        result.generateContractInfo.extractionNumber = ''
        result.generateContractInfo.watermarkFlag = false
      }

      // 项目类型数据处理
      if (!this.projectTypeData.includes(result.projectType)) {
        result.specificProjectType = []
      }

      // 团队合同：清空硬盘选购信息（页面 v-if 包含 contractType !== 'TEAM'）
      if (result.contractType === 'TEAM') {
        result.hardDiskPurchaseInfo = []
      }

      // 处理项目数据
      result.specificProjectType.forEach(item => {
        item.projectSampleDataList.forEach(dataItem => {
          if (dataItem.projectList.length > 0 && !['METAPRO', '硬盘购买', 'PCR'].includes(item.projectClassification)) {
            const newSizeOfSampleData = dataItem.projectList.reduce((acc, projectItem) => {
              if (projectItem.boolean) {
                let size = projectItem.size
                const unit = size.replace(/[0-9.]/g, '').toLowerCase()
                const numericValue = parseFloat(size.replace(/[^\d.]/g, ''))
                switch (unit) {
                  case 'w': size = numericValue * 10000; break
                  case 'm': size = numericValue * 1000000; break
                  default: size = numericValue; break
                }
                acc[projectItem.key] = size
              }
              return acc
            }, {})
            this.$set(dataItem, 'sizeOfSampleData', newSizeOfSampleData)
          }
          if (item.experimental.length > 0) {
            let num = 0
            const list = item.experimental.filter(itemA => item.labList.includes(itemA.experimentName))
            for (const data of list) {
              const number = data.numberOfExperiment
              num = num + Number(number ? number : 0)
            }
            this.$set(dataItem, 'numberOfSamples', num)
            this.$set(item, 'experimentalProcessItems', item.experimental.filter(it => item.labList.includes(it.experimentName)))
          }
        })

        // 二代/三代平台清空
        const hasSecondGen = item.projectSampleDataList.some(di =>
          Array.isArray(di.projectList) && di.projectList.some(p => p.name === '二代' && p.boolean)
        )
        if (!hasSecondGen) {
          this.$set(item, 'sequencingPlatform', '')
        }
        const hasThirdGen = item.projectSampleDataList.some(di =>
          Array.isArray(di.projectList) && di.projectList.some(p => p.name === '三代' && p.boolean)
        )
        if (!hasThirdGen) {
          this.$set(item, 'thirdSequencingPlatform', '')
          this.$set(item, 'tesThirdSequencingPlatform', '')
        }

        // 分析要求
        if (item.projectClassification !== '硬盘购买' && !['预付款扣款（裸测）', '裸测'].includes(result.projectType)) {
          if (item.analysis === '标准分析') {
            item.analyzeRequirements = '标准分析'
            // 与销售合同页一致：仅当可选项只有「标准分析」这一项时才不采用勾选值
            if (item.analysisChoiceList.length > 0 && !(item.analysisChoiceList.includes('标准分析') && item.analysisChoiceList.length === 1)) {
              item.analyzeRequirements = item.analysisList.join('/')
            }
          } else {
            item.analyzeRequirements = '非标准分析'
          }
        } else {
          item.analyzeRequirements = ''
        }
      })

      // 物料清空
      if (!(this.targetList.includes(result.projectType) || (['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => result.specificProjectType.map(project => project.projectType).includes(item)) && result.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'))) {
        result.materials = []
      }

      // 保护液信息
      if (!['单细胞解离转录组-C4', '单细胞解离转录组-10X', '单细胞解离转录组'].some(item => result.specificProjectType.map(project => project.projectType).includes(item))) {
        result.protectiveFluidInfo = {}
      } else {
        if (result.protectiveFluidInfo.protectiveFluidMethod === 'MAIL') {
          result.protectiveFluidInfo.doorInfo = {}
        } else {
          result.protectiveFluidInfo.materialMailInfo = {}
        }
      }

      // 非团队合同+纯分析时清空纯分析项目选择
      if (!(result.contractType === 'TEAM' && result.projectType === '纯分析')) {
        result.pureAnalysisInfo = null
      } else if (result.pureAnalysisInfo) {
        // 提交前剥离仅供 UI 使用的合同下拉选项；仅售后分析/原始数据重释放需要提交合同组
        const info = result.pureAnalysisInfo
        if (['AFTER_SALES_ANALYSIS', 'RAW_DATA_RERELEASE'].includes(info.pureAnalysisType)) {
          info.contracts = (Array.isArray(info.contracts) ? info.contracts : []).map(c => ({
            contractId: c.contractId,
            projectIds: Array.isArray(c.projectIds) ? c.projectIds : []
          }))
        } else {
          info.contracts = []
        }
      }

      return result
    },
    async openTemplate() {
      const [contractFormValid] = await Promise.all([
        this.validateForm('formContract')
      ])
      if (contractFormValid) {
        const amountValidation = this.validateTeamContractAmount()
        if (!amountValidation.valid) {
          this.$messageUi.error(amountValidation.message)
          return
        }
        const pureValidation = this.validatePureAnalysisContracts()
        if (!pureValidation.valid) {
          this.$messageUi.error(pureValidation.message)
          return
        }
        const formContract = this.buildContractPayload(this.formContract)

        const data = {
          customizeFlag: true,
          sales: formContract.salesId,
          contact: formContract.customerContactsId,
          partyB: formContract.trusteeContactsId,
          sequencingContractInputBo: Object.keys(formContract).reduce((acc, key) => {
            if (!['customizedAnalysisFile', 'seniorAnalysisFile', 'salesId', 'customerContactsId', 'trusteeContactsId'].includes(key)) {
              acc[key] = formContract[key]
            }
            return acc
          }, {})
        }

        const response = await templateGeneration(data)
        if (!response || !response.file) {
          return
        }
        const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type })
        this.templateFile = {
          name: file.name,
          status: 'ready',
          url: '',
          raw: file,
        }
        this.templateFileName = file.name
        this.$messageUi.success('已生成合同')
      } else {
        this.$nextTick(() => {
          const err = document.getElementsByClassName('is-error')
          if (err.length) {
            err[0].scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            })
          }
        })
        this.$messageUi.error('填写参数不规范，请检查')
      }
    },
    async loadTemplate() {
      try {
        if (!this.templateFile) {
          this.$messageUi.error('文件不存在，请检查')
          return
        }
        fileDownload(this.templateFile.raw, this.templateFile.raw.name)
      } catch (error) {
        console.log(error);
      }
    },
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传');
    },
    handleChange(files, type) {
      switch (type) {
        case 'senior':
          this.formContract.seniorAnalysisFile = files[0]
          this.seniorFileList = [files[0]]
          this.seniorFileName = files[0].name
          break
        case 'customized':
          this.formContract.customizedAnalysisFile = files[0]
          this.customizedFileList = [files[0]]
          this.customizedFileName = files[0].name
          break
        default:
          break
      }
    },

    getCurrentDate(data) {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
      const day = date.getDate().toString().padStart(2, '0'); // 日期
      if (data === 'sign') {
        return `${year}-${month}-${day}`
      } else {
        return `${year}${month}${day}`
      }
    },
    // 复制
    copyData(text) {
      copyText(text)
      this.$messageUi.success('复制成功')
    }
  },
}
</script>

<style scoped>
.upload-demo {

  /*margin-top: 20px;*/
  width: 100% !important;
}

:deep(.el-upload) {
  display: flex;
  gap: 20px;
  width: 100% !important;
}

.invoice-box {
  border: 1px dashed #ccc;
  /* 虚线框 */
  padding: 20px 20px 0 0;
  margin-bottom: 20px;
}

.bold-text {
  font-weight: bold;
  color: red;
  background-color: yellow;
  font-size: 16px;
}

.checkbox-group {
  display: flex;
  flex-wrap: nowrap;
  /* 禁止换行 */
}

.custom-style {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 0 0;
  /* 默认不显示上边框 */

}

.first-item {
  border-top: 1px dashed #d9d9d9;
  /* 第一个元素显示上边框 */
}

.formDiv {
  display: flex;
  flex-wrap: wrap;
}

.el-form-item {
  width: 45% !important;
}

:deep(.el-select) {
  width: 100%;
}

.el-form-item__label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}

.no-border-select .el-input__inner {
  border: none;
  box-shadow: none;
  background: transparent;
  /* 背景透明，与表格融合 */
}

.no-border-select .el-textarea__inner {
  border: none;
  box-shadow: none;
  background: transparent;
  /* 背景透明，与表格融合 */
}

.el-input.is-disabled .el-input__icon {
  display: none;
}

.custom-style {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 0 0;
  /* 默认不显示上边框 */

}

.first-item {
  border-top: 1px dashed #d9d9d9;
  /* 第一个元素显示上边框 */
}

/*.formDiv .el*/
</style>
